/*eslint-disable*/
export default sizeGuideHeaders => {
	let categoryRow = document.querySelector('.size-guide.popup .js-category-row')
	let categoryRowSlider;
	const leftControl = $(sizeGuideButton).find('.js-sizeguide-left')
	const rightControl = $(sizeGuideButton).find('.js-sizeguide-right')
}


// WEBPACK FOOTER //
// ./src/scripts/components/mobile-size-guide-flickity.js